//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
let d=[[],[[["fiberType","numAttributes","annotationAttrs"],"GetAnnotationAttributes",{},1,0],[["fiberType","annotationAttrs"],"SetAnnotationAttributes",{},2,0],[[],"ResetToDefault",{},0,0]],[]];
SPLM.AME.OpticalAnnotationSettingsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.OpticalAnnotationSettingsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.OpticalAnnotationSettingsBuilder.AnnotationAttrType = Object.freeze({
    "SourceTarget" : "SourceTarget", "FiberType" : "FiberType", "CoreDiameter" : "CoreDiameter", "CladdingDiameter" : "CladdingDiameter", "ObjectName" : "ObjectName", "CutLength" : "CutLength"});

export default SPLM;